import { Button, OverlayTrigger, Popover } from "react-bootstrap";
import { DataGridCellBadge } from "./DataGridCellBadge";
import classNames from "classnames";
import { useColor } from "components/utils/color";
import Color from "color";

export const DataGridCellBadges: React.FC<{
    items: string[];
    visibleItems: string[];
    badgeClassName?: string;
    badgeStyle?: React.CSSProperties;
}> = ({ items, visibleItems, badgeClassName, badgeStyle }) => {
    let primaryColor = useColor("primary");
    const isPrimaryColorLight = Color(badgeStyle?.backgroundColor ?? primaryColor).isLight();
    const textColor = isPrimaryColorLight ? "var(--bs-dark)" : "var(--bs-light)";

    return (
        <>
            <div className="d-flex gap-1 pb-1 flex-wrap">
                {visibleItems.map((item, idx) => (
                    <DataGridCellBadge key={idx} style={badgeStyle} showTooltip className={badgeClassName} item={item} />
                ))}
            </div>
            {items.length - visibleItems.length > 0 && (
                <OverlayTrigger
                    trigger={["hover", "focus"]}
                    overlay={
                        <Popover className={"bg-white"}>
                            <Popover.Body className="d-flex flex-wrap gap-1">
                                {items.map((item, idx: number) => (
                                    <DataGridCellBadge
                                        key={idx}
                                        style={{ ...badgeStyle, maxWidth: "none" }}
                                        className={badgeClassName}
                                        item={item}
                                    />
                                ))}
                            </Popover.Body>
                        </Popover>
                    }
                >
                    <Button
                        style={{ ...badgeStyle, color: badgeStyle?.color ?? textColor }}
                        className={classNames("fs-8 badge", { "bg-primary": !badgeStyle?.backgroundColor }, badgeClassName)}
                    >
                        +{items.length - visibleItems.length}
                    </Button>
                </OverlayTrigger>
            )}
        </>
    );
};
